import { render, staticRenderFns } from "./LoyaltyAnalytics.vue?vue&type=template&id=0fa0dace&scoped=true&lang=pug&"
import script from "./LoyaltyAnalytics.vue?vue&type=script&lang=js&"
export * from "./LoyaltyAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa0dace",
  null
  
)

export default component.exports